import { slot } from 'ts-event-bus';

export const DefaultChannelEvents = {
    notify: slot<{ event: string; data: any }>(),
    notification: slot<{ from?: string; event: string; data: any }>(),
};
